
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  collection,
  onSnapshot,
  query,
  limit,
} from "firebase/firestore";

import { db } from "../firebase";
import VolatilityHeader from "./VolatilityHeader";
import "./Developers.css";

const sections = [
  {
    icon: "⚙️",
    title: "Automation & Bots",
    description:
      "Jifunze jinsi automation na bots zinavyotumika kwenye BFC Trade.",
    details: [
      "Bots hufuata mipangilio iliyowekwa.",
      "Matokeo hutegemea logic na huduma zilizounganishwa.",
      "Automation haihakikishi faida.",
    ],
  },
  {
    icon: "📈",
    title: "Trading System",
    description:
      "Maelezo kuhusu mchakato wa trading na rekodi za shughuli.",
    details: [
      "Kagua taarifa za order kabla ya kuituma.",
      "Hifadhi rekodi za shughuli zilizotekelezwa.",
      "Trading execution inahitaji mfumo husika kuunganishwa.",
    ],
  },
  {
    icon: "🗄️",
    title: "Database & Records",
    description:
      "Database inaweza kuhifadhi taarifa za akaunti na historia.",
    details: [
      "Taarifa za akaunti.",
      "Historia ya orders na shughuli.",
      "Ufikiaji hutegemea ruhusa za database.",
    ],
  },
  {
    icon: "🔐",
    title: "Security",
    description:
      "Usalama wa akaunti na taarifa za mtumiaji ni muhimu.",
    details: [
      "Tumia nenosiri imara.",
      "Linda taarifa za kuingia.",
      "Ruhusa nyeti zithibitishwe upande wa server.",
    ],
  },
];

const footballSystems = [
  {
    icon: "⚽",
    title: "AntScore",
    description:
      "Mfumo wa AntScore unaopatikana kwenye huduma za football za BFC Trade.",
    details: [
      "Fuata maelekezo ya mfumo kabla ya kushiriki.",
      "Matokeo ya michezo hayawezi kuhakikishwa.",
    ],
  },
  {
    icon: "🔄",
    title: "Kubet Kinyume cha Matokeo",
    description:
      "Mfumo wa betting unaohusiana na kuchagua matokeo kinyume, kulingana na market inayotumika.",
    details: [
      "Soma masharti ya market husika.",
      "Betting inaweza kusababisha hasara.",
    ],
  },
  {
    icon: "🎯",
    title: "Correct Score",
    description:
      "Mfumo wa kuchagua matokeo kamili ya mchezo, kwa mfano 2–1 au 1–0.",
    details: [
      "Chagua score kulingana na chaguo zinazopatikana.",
      "Matokeo halisi yanaweza kutofautiana na utabiri.",
    ],
  },
  {
    icon: "🛡️",
    title: "Lost Compensation",
    description:
      "Sera ya fidia kwa hasara zinazostahili kwenye michezo inayotolewa na BFC Trade.",
    details: [
      "Fidia hutegemea masharti rasmi ya jukwaa.",
      "Kiasi, michezo inayostahili na muda wa malipo viwekwe wazi.",
    ],
  },
];

const tradingSystems = [
  {
    icon: "💱",
    title: "Forex Trading",
    description:
      "Huduma za Forex Trading kuanzia Jumatatu hadi Ijumaa.",
    details: [
      "Hufuatilia masoko ya jozi za sarafu.",
      "Upatikanaji hutegemea soko na huduma zilizounganishwa.",
      "Trading inaweza kusababisha hasara.",
    ],
  },
  {
    icon: "📡",
    title: "Free Crypto Signals",
    description:
      "BFC Trade hutoa signals 3 za cryptocurrency bila malipo.",
    details: [
      "Kagua maelezo ya kila signal kabla ya kuitumia.",
      "Fuata entry, stop-loss na take-profit ikiwa vimetolewa.",
      "Signals hazihakikishi faida.",
    ],
  },
  {
    icon: "🪙",
    title: "Crypto Holding",
    description:
      "Huduma ya kushikilia cryptocurrency (hold coin) kulingana na mkakati wa mtumiaji.",
    details: [
      "Thamani ya coin inaweza kupanda au kushuka.",
      "Fikiria usalama wa wallet na ada zinazoweza kutumika.",
      "Holding haihakikishi faida.",
    ],
  },
  {
    icon: "🌊",
    title: "Driv Volatility System",
    description:
      "Mfumo wa crypto trading unaozingatia mabadiliko ya bei (volatility).",
    details: [
      "Tumia maelekezo na vigezo vya mfumo.",
      "Volatility inaweza kuongeza faida au hasara.",
      "Matokeo hutegemea mkakati na hali ya soko.",
    ],
  },
];

const faqs = [
  {
    question: "BFC Trade ina huduma zipi?",
    answer:
      "BFC Trade ina mifumo ya football betting, Forex Trading, crypto signals, crypto holding na Driv Volatility System. Upatikanaji wa kila huduma hutegemea utekelezaji wake kwenye jukwaa.",
  },
  {
    question: "Forex Trading hufanyika siku gani?",
    answer:
      "Huduma ya Forex Trading ya BFC Trade imeelezwa kuwa kuanzia Jumatatu hadi Ijumaa. Saa na upatikanaji vinaweza kutegemea soko na huduma zilizounganishwa.",
  },
  {
    question: "Crypto signals ni ngapi?",
    answer:
      "BFC Trade hutoa signals 3 za crypto bila malipo. Muda wa utoaji wa signals unapaswa kuthibitishwa kwenye taarifa rasmi za jukwaa.",
  },
  {
    question: "Je, trading inahakikisha faida?",
    answer:
      "Hapana. Forex, crypto na betting vina hatari ya hasara. Signals, bots na mifumo ya uchambuzi haiwezi kuhakikisha matokeo.",
  },
  {
    question: "Firestore ikiwa connected inamaanisha trading inafanya kazi?",
    answer:
      "Hapana. Hali ya Firestore inaonyesha muunganisho wa database pekee. Haithibitishi trading execution, settlement au malipo.",
  },
  {
    question: "Lost Compensation inafanyaje kazi?",
    answer:
      "Fidia inapaswa kufuata masharti rasmi ya BFC Trade, ikiwemo michezo inayostahili, kiwango cha fidia na muda wa madai.",
  },
];

function FeatureCard({ item, index }) {
  return (
    <article className="dev-feature-card">
      <div className="dev-feature-top">
        <span className="dev-feature-icon">{item.icon}</span>
        <span className="dev-feature-number">
          {String(index + 1).padStart(2, "0")}
        </span>
      </div>

      <h3>{item.title}</h3>
      <p>{item.description}</p>

      <ul>
        {item.details.map((detail) => (
          <li key={detail}>{detail}</li>
        ))}
      </ul>
    </article>
  );
}

function SystemSection({ eyebrow, title, intro, items, id }) {
  return (
    <section className="developers-section" id={id}>
      <div className="dev-section-heading">
        <span className="developers-eyebrow">{eyebrow}</span>
        <h2>{title}</h2>
        <p>{intro}</p>
      </div>

      <div className="developers-feature-grid">
        {items.map((item, index) => (
          <FeatureCard
            item={item}
            index={index}
            key={item.title}
          />
        ))}
      </div>
    </section>
  );
}

export default function Developers() {
  const navigate = useNavigate();
  const [connection, setConnection] = useState("checking");
  const [openFaq, setOpenFaq] = useState(0);

  useEffect(() => {
    let settled = false;

    const timer = setTimeout(() => {
      if (!settled) {
        setConnection("unavailable");
      }
    }, 10000);

    const unsubscribe = onSnapshot(
      query(collection(db, "users"), limit(1)),
      () => {
        settled = true;
        clearTimeout(timer);
        setConnection("connected");
      },
      (error) => {
        settled = true;
        clearTimeout(timer);
        console.error(
          "BFC Trade status check failed:",
          error
        );
        setConnection("unavailable");
      }
    );

    return () => {
      settled = true;
      clearTimeout(timer);
      unsubscribe();
    };
  }, []);

  const statusText = {
    checking: "Inakagua muunganisho...",
    connected: "Firestore imeunganishwa",
    unavailable: "Muunganisho haujathibitishwa",
  };

  return (
    <div className="developers-page">
      <VolatilityHeader />

      <main className="developers-container">
        {/* HERO */}
        <section className="developers-hero">
          <div className="developers-hero-content">
            <span className="developers-eyebrow">
              BFC TRADE • PLATFORM INFORMATION
            </span>

            <h1>
              Jifunze kuhusu <span>BFC Trade</span>
            </h1>

            <p>
              Fahamu mifumo ya football betting, Forex,
              cryptocurrency, automation na huduma za jukwaa.
            </p>

            <div className="developers-hero-actions">
              <button
                type="button"
                className="dev-button dev-button-primary"
                onClick={() =>
                  document
                    .getElementById("how-it-works")
                    ?.scrollIntoView({ behavior: "smooth" })
                }
              >
                Jinsi inavyofanya kazi ↓
              </button>

              <button
                type="button"
                className="dev-button dev-button-secondary"
                onClick={() =>
                  navigate("/volatility-history")
                }
              >
                Angalia History
              </button>
            </div>
          </div>

          <div
            className="developers-hero-art"
            aria-hidden="true"
          >
            <div className="dev-orbit dev-orbit-one" />
            <div className="dev-orbit dev-orbit-two" />
            <div className="dev-orbit dev-orbit-three" />
            <div className="dev-core">BFC</div>

            <span className="dev-floating dev-floating-one">
              FOOTBALL
            </span>

            <span className="dev-floating dev-floating-two">
              FOREX
            </span>

            <span className="dev-floating dev-floating-three">
              CRYPTO
            </span>
          </div>
        </section>

        {/* FIRESTORE STATUS */}
        <section className="developers-status">
          <div className="dev-status-icon">◉</div>

          <div className="dev-status-copy">
            <h2>Muunganisho wa mfumo</h2>
            <p>{statusText[connection]}</p>
          </div>

          <span
            className={`dev-status-indicator status-${connection}`}
            aria-label={statusText[connection]}
          />
        </section>

        {/* GENERAL SYSTEMS */}
        <SystemSection
          id="how-it-works"
          eyebrow="PLATFORM OVERVIEW"
          title="Jukwaa linafanyaje kazi?"
          intro="Hizi ni sehemu kuu za mfumo na majukumu yake. Upatikanaji wa kila kipengele hutegemea utekelezaji wake."
          items={sections}
        />

        {/* FOOTBALL BETTING */}
        <SystemSection
          eyebrow="BFC TRADE • FOOTBALL SYSTEMS"
          title="Mifumo ya Football Betting"
          intro="BFC Trade ina mifumo ya AntScore, kubet kinyume cha matokeo na Correct Score, pamoja na sera ya Lost Compensation kulingana na masharti ya jukwaa."
          items={footballSystems}
        />

        {/* FOREX AND CRYPTO */}
        <SystemSection
          eyebrow="BFC TRADE • FINANCIAL MARKETS"
          title="Forex & Crypto Trading"
          intro="Gundua Forex Trading kuanzia Jumatatu hadi Ijumaa, crypto signals 3 za bure, crypto holding na Driv Volatility System."
          items={tradingSystems}
        />

        {/* PROCESS */}
        <section className="developers-section">
          <div className="dev-section-heading">
            <span className="developers-eyebrow">
              PROCESS
            </span>
            <h2>Mchakato wa mfumo</h2>
          </div>

          <div className="dev-process">
            <article className="dev-process-step">
              <span>01</span>
              <div>
                <h3>Mtumiaji</h3>
                <p>
                  Mtumiaji hufungua akaunti na kuchagua huduma
                  inayopatikana.
                </p>
              </div>
            </article>

            <div className="dev-process-line" />

            <article className="dev-process-step">
              <span>02</span>
              <div>
                <h3>Programu</h3>
                <p>
                  Programu huchakata maombi kulingana na logic
                  na mipangilio iliyotekelezwa.
                </p>
              </div>
            </article>

            <div className="dev-process-line" />

            <article className="dev-process-step">
              <span>03</span>
              <div>
                <h3>Database</h3>
                <p>
                  Taarifa husomwa au kuhifadhiwa kulingana na
                  ruhusa na taratibu za mfumo.
                </p>
              </div>
            </article>

            <div className="dev-process-line" />

            <article className="dev-process-step">
              <span>04</span>
              <div>
                <h3>Matokeo</h3>
                <p>
                  Mtumiaji huonyeshwa taarifa ambazo mfumo
                  umeweza kuthibitisha na kurekodi.
                </p>
              </div>
            </article>
          </div>
        </section>

        {/* FAQ */}
        <section className="developers-section">
          <div className="dev-section-heading">
            <span className="developers-eyebrow">
              HELP CENTER
            </span>
            <h2>Maswali yanayoulizwa mara kwa mara</h2>
          </div>

          <div className="dev-faq-list">
            {faqs.map((faq, index) => (
              <article
                className={`dev-faq-item ${
                  openFaq === index ? "is-open" : ""
                }`}
                key={faq.question}
              >
                <button
                  type="button"
                  className="dev-faq-question"
                  aria-expanded={openFaq === index}
                  onClick={() =>
                    setOpenFaq(
                      openFaq === index ? -1 : index
                    )
                  }
                >
                  <span>{faq.question}</span>
                  <span className="dev-faq-toggle">
                    {openFaq === index ? "−" : "+"}
                  </span>
                </button>

                {openFaq === index && (
                  <div className="dev-faq-answer">
                    {faq.answer}
                  </div>
                )}
              </article>
            ))}
          </div>
        </section>

        {/* DISCLAIMER */}
        <section className="developers-disclaimer">
          <span className="dev-disclaimer-icon">ⓘ</span>

          <div>
            <h3>Taarifa muhimu</h3>
            <p>
              Forex, cryptocurrency na betting vina hatari ya
              kifedha na vinaweza kusababisha hasara. Maelezo
              haya hayaahidi faida wala hayathibitishi kuwa
              signals, bots, trading execution, settlement au
              fidia vinafanya kazi kiotomatiki. Huduma hizo
              zinahitaji utekelezaji na masharti yaliyo wazi.
            </p>
          </div>
        </section>

        {/* FOOTER */}
        <footer className="developers-footer">
          <strong>BFC Trade</strong>
          <span>Platform Information Center</span>
        </footer>
      </main>
    </div>
  );
}
